import OapContrastSwitcher from './code/Scripts/components/OapContrastSwitcher';

export default {
  components: {
    OapContrastSwitcher,
  },
};
